import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type ActiveConsent = { version: string; consent_text: string };

const FALLBACK: ActiveConsent = {
  version: "v1.0",
  consent_text:
    "I consent to receiving intelligence briefs by email and agree to the Privacy Policy. I can unsubscribe at any time.",
};

let cache: ActiveConsent | null = null;
let inflight: Promise<ActiveConsent> | null = null;

async function fetchActive(): Promise<ActiveConsent> {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data } = await supabase
        .from("consent_versions")
        .select("version, consent_text")
        .eq("is_active", true)
        .maybeSingle();
      cache = (data as ActiveConsent | null) ?? FALLBACK;
      return cache;
    } catch {
      cache = FALLBACK;
      return cache;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function useActiveConsent(): ActiveConsent {
  const [consent, setConsent] = useState<ActiveConsent>(cache ?? FALLBACK);
  useEffect(() => {
    let cancelled = false;
    fetchActive().then((c) => { if (!cancelled) setConsent(c); });
    return () => { cancelled = true; };
  }, []);
  return consent;
}

export function clearConsentCache() { cache = null; }
